<template>
  <div>
    <v-layout>
      <v-data-table
        :headers="$getHeaderType1(headerTxt, headers)"
        :items="licensees"
        hide-default-footer
        disable-pagination
        disable-sort
        class="new__type__table__view"
      >
        <template v-slot:item="{ item, index }">
          <tr @click="fnOpenModifyForm(item.seq)">
            <td>
              {{index + 1}}
            </td>
            <td>
              <p>{{item.name.name_ar}}</p>
              <p>{{item.name.name_en}}</p>
            </td>
            <td>
              <p>{{item.address.address_ar}}</p>
              <p>{{item.address.address_en}}</p>
            </td>
            <td>
              {{item.nationality_code}}
            </td>
            <td>
              {{item.residence_country_code}}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-layout>
    <v-layout class="mt-15">
      <v-spacer></v-spacer>
      <v-btn
        dense
        dark
        outlined
        width="110px"
        height="40px"
        color="#a01c2a"
        class="capitalize"
        @click="add_dialog = true"
      >
        {{$t('common.button.add')}}
      </v-btn>
    </v-layout>

    <!-- Add Dialog -->
    <LicenseesAdd v-if="add_dialog" :receipt_no="receipt_no" @success="fnSuccess()"/>

    <!-- Add Dialog -->
    <LicenseesMod v-if="mod_dialog" :receipt_no="receipt_no" :seq.sync="seq" @success="fnSuccess()"/>
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import LicenseesAdd from './RegisterLicenseLicenseesAdd'
import LicenseesMod from './RegisterLicenseLicenseesMod'

export default {
  props: {
    receipt_no : String
  },
  components :{
    LicenseesAdd,
    LicenseesMod
  },
  data() {
    return {
      add_dialog : false,
      mod_dialog : false,

      headerTxt : {
        prefix : 'modification.register_license.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code' ]
      },

      headers: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: 'Name', align: 'center', value: 'name', width:'250' },
        { text: 'Address', align: 'center', sortable: false, value: 'address' },
        { text: 'Nationality Country Code', sortable: false, align: 'center', value: 'nationality_code', width:'100'},
        { text: 'Residence Country Code', sortable: false, align: 'center', value: 'residence_country_code', width:'100'},
      ],

      licensees: [],

      seq : ''
    }
  },
  mounted(){
    this.fnGetLicensees()
  },
  methods: {
    fnGetLicensees(){
      requestApi({
        url: '/receivings/register/license/'+this.receipt_no+'/licensees',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            this.licensees = []

            for(let i=0; i<res.data.list.length; i++){
              let item = {
                seq : res.data.list[i].seq,
                nationality_code : res.data.list[i].nationality_code,
                residence_country_code : res.data.list[i].residence_country_code,
                name : { name_ar : res.data.list[i].name_ar, name_en : res.data.list[i].name_en },
                address : { address_ar : res.data.list[i].address_ar, address_en : res.data.list[i].address_en },
                email : res.data.list[i].email
              }

              this.licensees.push(item)
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetLicensees()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSuccess(){
      this.add_dialog = false
      this.mod_dialog = false
      this.fnGetLicensees()
    },

    fnOpenModifyForm(seq){
      this.seq = seq
      this.mod_dialog = true
    }
  }
}
</script>